import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {

    const navigate = useNavigate();
    const token = localStorage.getItem("olympusMons");

    useEffect(() => {
        document.body.classList.add("auth-page");

        return () => {
            document.body.classList.remove("auth-page");
        };
    }, []);

    return (
        <div
            style={{
                height: "100vh",
                backgroundColor: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
            }}
        >
            <p
                style={{
                    fontSize: "120px",
                    fontWeight: "bold",
                    color: "#FC4420",
                    textShadow: "0 0 20px rgba(252,68,32,0.6)",
                }}
            >
                404
            </p>

            <p
                style={{
                    fontSize: "32px",
                    color: "#fff",
                    fontWeight: 600,
                    mb: 2,
                }}
            >
                Page Not Found!
            </p>

            <p
                style={{
                    color: "#FC4420",
                    mb: 4,
                }}
            >
                Sorry we can't seem to find the page you're looking for. It might be an
                old link or maybe it moved.
            </p>

            <Button
                onClick={() => navigate(token ? "/dashboard" : "/401")}
                sx={{
                    backgroundColor: "#FC4420",
                    color: "#fff",
                    px: 4,
                    py: 1,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        backgroundColor: "#ff5a36",
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 20px rgba(252,68,32,0.4)",
                    },
                }}
            >
                Go Home
            </Button>
        </div>
    );
};

export default NotFound;
